import React, { FC } from 'react';
import { MulticolorProgressBar, AllieText } from '../../../../components';
import { FlexContainer } from '../StationListSummaryCard.styles';
import { AllieColors } from '../../../../common/color.types';

interface ProgressContainerProps {
  barData: {
    value: number;
    color: AllieColors;
  }[];
  shiftStartsAt: string;
  shiftEndsAt: string;
  progressBarHeight?: string;
}

export const ProgressContainer: FC<ProgressContainerProps> = ({
  barData,
  shiftEndsAt,
  shiftStartsAt,
  progressBarHeight = '69px',
}) => {
  return (
    <FlexContainer
      flexDirection="column"
      justifyContent="space-between"
      gap={10}
      style={{ height: '100%' }}
    >
      <MulticolorProgressBar
        values={barData}
        height={progressBarHeight}
        showEndArrow={true}
        overflow="unset"
        display="inline-flex"
      />
      <FlexContainer justifyContent="space-between">
        <AllieText type="body3" color="neutral-60">
          {shiftStartsAt}
        </AllieText>
        <AllieText type="body3" color="neutral-60">
          {shiftEndsAt}
        </AllieText>
      </FlexContainer>
    </FlexContainer>
  );
};
